import { useEffect, useRef, useState } from 'react';

interface Props {
  shouldUpdateArrows?: boolean;
  initialIndex?: number;
  offset?: number;
}

interface CarouselActions {
  carouselRef: React.MutableRefObject<any>;
  carouselNext: () => void;
  carouselPrevious: () => void;
  previousDisabled: boolean;
  nextDisabled: boolean;
}

function useCarousel({ shouldUpdateArrows = true, initialIndex = 0, offset = 0 }: Props = {}): CarouselActions {
  const carouselRef: React.MutableRefObject<any> = useRef(null);
  const [previousDisabled, setPreviousDisabled] = useState(!!shouldUpdateArrows && initialIndex === 0);
  const [nextDisabled, setNextDisabled] = useState(false);
  const flickity = carouselRef?.current;

  const updateArrows = () => {
    if (!shouldUpdateArrows) {
      return;
    }

    setTimeout(() => {
      const { slides, selectedIndex } = flickity;
      const lastIndex = slides.length ? slides.length - 1 : 0;

      if (selectedIndex === lastIndex - offset) {
        setNextDisabled(true);
        setPreviousDisabled(false);
      } else if (selectedIndex === offset) {
        setNextDisabled(false);
        setPreviousDisabled(true);
      } else {
        setNextDisabled(false);
        setPreviousDisabled(false);
      }
    }, 1000);
  };

  const carouselNext = () => {
    if (flickity) {
      flickity.next();
      // updateArrows();
    }
  };

  const carouselPrevious = () => {
    if (flickity) {
      flickity.previous();
      // updateArrows();
    }
  };

  useEffect(() => {
    if (flickity) {
      flickity.on('dragEnd', () => {
        // updateArrows();
      });
    }
  }, [flickity]);

  return { carouselRef, carouselNext, carouselPrevious, previousDisabled: false, nextDisabled: false };
}

export default useCarousel;
